import { render } from "./ChatAssistant.vue?vue&type=template&id=4074c374&scoped=true&ts=true"
import script from "./ChatAssistant.vue?vue&type=script&lang=ts"
export * from "./ChatAssistant.vue?vue&type=script&lang=ts"

import "./ChatAssistant.vue?vue&type=style&index=0&id=4074c374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4074c374"]])

export default __exports__